interface NotificationProps {
  message: string;
}

const Notification: React.FC<NotificationProps> = ({ message }) => {
  return (
    <div
      role="alert"
      className="el-notification right"
      style={{ top: 16, zIndex: 2011 }}
    >
      <i className="el-notification__icon el-icon-warning"></i>
      <div className="el-notification__group is-with-icon">
        <div className="el-notification__content">
          <p>{message}</p>
        </div>
        <div className="el-notification__closeBtn el-icon-close"></div>
      </div>
    </div>
  );
};

export default Notification;
